export enum GamingType {
    PENDING,
    ONGOING,
}
